import React, { useState } from 'react';

import { useDispatch } from 'react-redux';

import Column from '@amzn/meridian/column';
import Select, { SelectOption } from '@amzn/meridian/select';
import Text from '@amzn/meridian/text';
import { setSelectedFilterOptions } from 'src/store/placementOverviewPageSlice';
import { useAppSelector } from 'src/store/store';
import { createSearchRegExp } from 'src/utils/searchUtils';

const MultipleJobTypeDropdown = () => {
  const dispatch = useDispatch();

  const { availableFilterOptions, selectedFilterOptions } = useAppSelector((state) => state.placementOverviewPage);
  const allJobTypes = availableFilterOptions.availableJobTypes;

  const [searchQuery, setSearchQuery] = useState();
  const searchRegExp = createSearchRegExp(searchQuery);

  const matchedJobTypeOptions = allJobTypes?.filter(
    (jobTypeName: string) => !searchQuery || searchRegExp.test(jobTypeName),
  );

  return (
    <Column spacing="100">
      <Text>Job Type</Text>
      <Select
        size="small"
        value={selectedFilterOptions.jobTypes}
        onChange={(newValue) => {
          dispatch(setSelectedFilterOptions({ ...selectedFilterOptions, jobTypes: newValue }));
        }}
        searchQuery={searchQuery}
        onSearch={setSearchQuery}
        placeholder="Enter value..."
      >
        {matchedJobTypeOptions?.map((jobType: string) => (
          <SelectOption label={jobType} value={jobType} key={jobType} />
        ))}
        {!matchedJobTypeOptions?.length ? (
          <Column alignmentVertical="center" spacing="300" spacingInset="500">
            <Text alignment="center">No results</Text>
          </Column>
        ) : null}
      </Select>
    </Column>
  );
};

export default MultipleJobTypeDropdown;
